module.exports = __webpack_public_path__ + "static/media/Out_Of_Coins_StaticImage@3x.6325f287.png";